import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { FeatureScopeState } from './feature-scope.reducer';

const getState = createSelector(getMenuState, (state: MenuState) => state.featureScope);
const getSelectedScope = createSelector(getState, (state: FeatureScopeState) => state.selectedScope);

export const FeatureScopeSelectors = {
    getSelectedScope
};
